// ** Core JWT Import
import UseJwt from "../core/useJwt";

const { jwt } = UseJwt({});

export default jwt;
